import React from 'react';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { WizardFormData } from '../schemas';
import { WizardTextField } from './WizardTextField';
import { WizardFileField } from './WizardFileField';
import { WizardAutocompleteField } from './WizardAutocompleteField';
import ParameterTable from './ParameterTable';
import { XmlRedirectFields } from '../../XmlRedirectField/XmlRedirectFields';
import { NETWORK_OPTIONS, XML_SAMPLE_PLACEHOLDER } from '../../../constants/trafficSource';

function AutoCreateTrafficSourceForm() {
  const { watch, setValue, formState: { errors } } = useFormContext<WizardFormData>();

  const network = watch('network')
  const xmlSample = watch('xmlSample')
  const xmlRedirectField = watch('xmlRedirectField')

  const isXmlNetwork = network === 'xml';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, ml: 4 }}>
      <WizardTextField label="Traffic Source Name" name="trafficSourceName" helperText="Default: [Offer Name] Source" />

      <WizardAutocompleteField
        label="Network"
        name="network"
        options={NETWORK_OPTIONS.map((opt) => ({ id: opt.value, label: opt.label }))}
        helperText="Select the network type for this offer"
      />

      {isXmlNetwork && (
        <XmlRedirectFields
          onSampleChange={(newSample) => {
            setValue('xmlSample', newSample);
          }}
          onRedirectFieldChange={(newRedirectField) => {
            setValue('xmlRedirectField', newRedirectField);
          }}
          values={{
            xmlSample,
            xmlRedirectField,
          }}
          size="medium"
          placeholder={XML_SAMPLE_PLACEHOLDER}
          errors={{
            xmlSample: errors.xmlSample?.message || '',
            xmlRedirectField: errors.xmlRedirectField?.message || '',
          }}
        />
      )}

      <ParameterTable />

      <WizardFileField label="Iron Dome CSV (Optional)" name="trafficSourceIronDomeFile" helperText="Upload a CSV file for Iron Dome integration" />
    </Box>
  );
}

export default AutoCreateTrafficSourceForm;
